import * as React from "react";
import { observer } from "mobx-react";
import { Loader, InstantCollapsible } from "sb-resp-ui";

// imported only for typings
// these are passed to the component from index.ts
import { BaseDict } from "./dict";
import { MyPulseBetsData, PulseBetTypeInfo, OpenPulseBetViewModel } from "./data";
// external components
import * as CMP from "./components";
import * as SCMP from "../../components";
import Debounce from "debounce-decorator";

@observer
export class MyPulseBets extends React.Component<{
    dataProvider: MyPulseBetsData,
    dict: BaseDict
}, {
    dataProvider: MyPulseBetsData
    changedResolution: boolean
}> {

    dict: BaseDict

    constructor(props) {
        super(props);

        this.dict = this.props.dict;

        // setup data provider
        this.state = {
            dataProvider: this.props.dataProvider,
            changedResolution: false
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this);
    }

    handleEvent(e: Event) {
        this.handleResizeEvent(e);
    }

    @Debounce(50)
    handleResizeEvent(e: Event) {
        if ( e.type === "resize") {
            this.setState((prevState) => (
                { changedResolution: !prevState.changedResolution }
            ));
        }
    }

    getKey(pulseBetTypeData:PulseBetTypeInfo) {
        return `eventTypeCollapsible-${pulseBetTypeData.eventTypeId}-${+this.state.changedResolution}`;
    }

    renderMyPulseBetContainer(pulseBetTypeData: PulseBetTypeInfo) {
        return (
            <div className="rj-my-pusle-bets__collapsible-wrap" key={this.getKey(pulseBetTypeData)}>
                <InstantCollapsible
                    trigger={
                        <CMP.SortedHeading text={pulseBetTypeData.eventTypeName} />
                    }
                    content={
                        <div className="rj-my-pulse-bets__main-container">
                            {this.state.dataProvider.getOpenPulseBets(pulseBetTypeData.eventTypeId).map(this.renderOpenPulseBets, this)}
                        </div>
                    }
                    initiallyExpanded={true}
                />
            </div>
        )
    }

    renderOpenPulseBets(myOpenPulseBet: OpenPulseBetViewModel) {
        return (
            <CMP.OpenPulseBet
                key={myOpenPulseBet.uniqueKey}
                viewModel={myOpenPulseBet}
                winMsg={this.dict.PulseBetMsgWin.format(myOpenPulseBet.formatedGain)}
                goMsg={this.dict.PulseBetMsgGoal}
                isGameRunning={this.state.dataProvider.isGameRunning}
                callbacks={
                    {
                        complete: this.state.dataProvider.updateWiningsStatusOnComplete.bind(this.state.dataProvider)
                    }
                }
                calculateState={this.state.dataProvider.reCalculateState.bind(this.state.dataProvider, myOpenPulseBet.purchaseId)}
            />
        )
    }

    renderLoader() {
        return (
            <div className="rj-my-pulse-bets__loader">
                <Loader />
            </div>
        )
    }

    renderMessage() {
        return (
            <div className="rj-my-pulse-bets__no-open-pulse-bets">
                {this.dict.NoOpenPulseBets}
            </div>
        )
    }

    renderAllPulseBets() {
        return (
            <>
            <SCMP.Heading label={this.dict.MyPulseBets} />
            {!this.state.dataProvider.openViewModels.length && (this.state.dataProvider.isAnyBetsAfterSettlement ? this.renderLoader() : this.renderMessage())}
            {(this.state.dataProvider.openViewModels.length > 0) &&
                this.state.dataProvider.pulseBetTypes.map(data => this.state.dataProvider.hasAnyOpenPulseBets(data.eventTypeId) && this.renderMyPulseBetContainer(data))
            }
            </>
        )
    }

    render() {
        return (
            <>
            {this.state.dataProvider.isMyPulseBetActive &&
                this.renderAllPulseBets()
            }
            </ >
        )
    }

}